var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightingBolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lighting bolt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Lighting bolt_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0041 3.7182C13.0041 3.45881 12.8296 3.23157 12.5804 3.16385C12.3302 3.09612 12.0666 3.20402 11.9355 3.4267L6.26243 13.0733C6.1578 13.2512 6.15676 13.4705 6.25881 13.6495C6.30439 13.7292 6.36759 13.7953 6.44166 13.8441C6.53386 13.9048 6.64316 13.9387 6.75712 13.9387H10.8384V20.2834C10.8384 20.5405 11.0104 20.7677 11.2595 20.8354C11.5076 20.9043 11.7713 20.7987 11.9044 20.5772L17.735 10.841C17.8417 10.6631 17.8443 10.4427 17.7417 10.2625C17.6397 10.0835 17.449 9.97218 17.2429 9.97218H13.0041V3.7182Z",
    fill: "#7E86A0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightingBolt);
export default __webpack_public_path__ + "static/media/lighting-bolt.f1f8c01dd2d64132e3759b17e1f8141f.svg";
export { ForwardRef as ReactComponent };